import React, { useCallback, useEffect } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import classNames from 'classnames';

import {
  COURSE_PAUSE_RESCHEDULE_MODAL_STAGES,
  selectedRequestSelector,
  setCoursePauseRescheduleModalStage,
  useUnscheduleRequestMutation,
} from 'features/courseResume';
import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import GlobalLoader from 'components/GlobalLoader';
import styles from './CoursePauseRescheduleModalUnscheduleStage.module.scss';

function CoursePauseRescheduleModalUnscheduleStage() {
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);
  const [unschedule, { isSuccess, error, isLoading: isUnscheduling }] =
    useUnscheduleRequestMutation();

  const handleProceedClick = useCallback(() => {
    if (isUnscheduling) return;

    unschedule({
      requestId: selectedRequest.id,
    });
  }, [unschedule, isUnscheduling, selectedRequest.id]);

  const handleBackClick = useCallback(() => {
    dispatch(
      setCoursePauseRescheduleModalStage(
        COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.notOpen
      )
    );
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        setCoursePauseRescheduleModalStage(
          COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.notOpen
        )
      );
      cogoToast.success(
        'Course pause request has been successfully unscheduled.'
      );
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isUnscheduling} />
      <div className={styles.root}>
        <Icon
          name="help-new"
          className="h2 m-b-xs"
        />
        <div className="h4 m-b-xs">
          Are you sure you want to Unschedule this request?
        </div>
        <Tappable
          className={classNames('btn btn-primary', styles.button)}
          disabled={isUnscheduling}
          onClick={handleProceedClick}
        >
          Yes
        </Tappable>
        <Tappable
          className={classNames(
            'btn btn-primary btn-inverted m-h-xxs',
            styles.button
          )}
          disabled={isUnscheduling}
          onClick={handleBackClick}
        >
          No
        </Tappable>
      </div>
    </>
  );
}

export default CoursePauseRescheduleModalUnscheduleStage;
